import { render, staticRenderFns } from "./ReminderLayoutEditor.vue?vue&type=template&id=6f2d0603"
import script from "./ReminderLayoutEditor.vue?vue&type=script&lang=ts"
export * from "./ReminderLayoutEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f2d0603')) {
      api.createRecord('6f2d0603', component.options)
    } else {
      api.reload('6f2d0603', component.options)
    }
    module.hot.accept("./ReminderLayoutEditor.vue?vue&type=template&id=6f2d0603", function () {
      api.rerender('6f2d0603', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reminder-layout-editor/ReminderLayoutEditor.vue"
export default component.exports